module.exports = __webpack_public_path__ + "media/images/login-40df9ab490c4c10ee741bded1b6a09b7.jpg";